var map = {
	"./AdminView": [
		673,
		[
			443,
			673
		]
	],
	"./ClienteView": [
		56,
		[
			56
		]
	],
	"./HotelView": [
		508,
		[
			508
		]
	],
	"./NegozioView": [
		861,
		[
			861
		]
	],
	"./OperatoreView": [
		841,
		[
			841
		]
	],
	"./ReferralView": [
		772,
		[
			391
		]
	],
	"./SuperadminView": [
		380,
		[
			443,
			380
		]
	]
};
function webpackAsyncContext(req) {
	try {
		if(!__webpack_require__.o(map, req)) {
			return Promise.resolve().then(() => {
	var e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
		}
	} catch(err) {
		return Promise.reject(err);
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids[1].map(__webpack_require__.e)).then(() => (__webpack_require__(id)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 565;
module.exports = webpackAsyncContext;